<div class="bg-white conteiner">

    <div class="content-delete flex flex justify-between">
        <div class="Texto w-full flex mt-5">
            <div class="warning flex justify-center pt-3 w-1/6">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
                    <circle cx="0.75em" cy="0.75em" r="0.75em" fill="#F2CB00" />
                    <path fill="#fff"
                        d="M11.351 6.351A1.2 1.2 0 0 1 13.4 7.2V12a1.2 1.2 0 1 1-2.4 0V7.2a1.2 1.2 0 0 1 .351-.849Zm.182 9.451a1.2 1.2 0 1 1 1.334 1.996 1.2 1.2 0 0 1-1.334-1.996Z" />
                </svg>
            </div>
            <div class="w-5/6">
                <p class="text">
                    <strong class="warningText">Warning!</strong> Deleting is
                    <strong>irreversible</strong>.
                </p>
                <p class="text">The action you're
                    about to take
                    <strong> can't
                        be undone.</strong> Going further will <strong> delete</strong> it and all the items in it
                    <strong>permanently</strong>.
                </p>
            </div>
        </div>
    </div>
</div>